<template>
  <v-dialog width="1000" fullscreen persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark card>
        <v-toolbar-title class="headline">{{ formTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon :disabled="isLoadingAddEdit" @click="cancel()">close</v-icon>
      </v-toolbar>
      <v-card-text>
        <v-layout wrap justify-center>
          <v-flex xs12 md9>
            <v-card
              v-if="fetching_data"
              color="grey"
              class="text-xs-center"
              dark
            >
              <v-card-text>
                Please stand by
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
            <v-card v-else class="mb-0" flat>
              <v-card-text style="height: auto">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row wrap>
                    <v-flex xs6 class="pr-4">
                      <v-layout column>
                        <v-flex xs12>
                          <!-- <div style="font-size:18px;">Promotion name :</div> -->
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            label="Name thai"
                            :disabled="isEditPromotion"
                            v-model="form.promotion_name_th"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            label="Name english"
                            :disabled="isEditPromotion"
                            v-model="form.promotion_name_en"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            :disabled="isEditPromotion"
                            label="Name china"
                            v-model="form.promotion_name_cn"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs6 class="pl-4">
                      <v-layout column>
                        <v-flex xs12>
                          <!-- <div style="margin-bottom:13px;font-size:18px;">Promotion description :</div> -->
                        </v-flex>
                        <v-textarea
                          label="Description"
                          :disabled="isEditPromotion"
                          rows="8"
                          v-model="form.promotion_detail"
                        ></v-textarea>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- ORDER TYPE -->
                  <v-layout row wrap class="mt-4">
                    <v-layout row wrap>
                      <v-flex xs12 style="font-size: 16px">
                        <p>Order type :</p>
                      </v-flex>
                      <v-flex xs12 class="pr-4">
                        <v-btn-toggle
                          v-model="form.promotion_order_type"
                          mandatory
                          @change="resetOrderTypeValue()"
                        >
                          <v-btn :disabled="isEditPromotion" :value="1"
                            >Food delivery</v-btn
                          >
                          <v-btn :disabled="isEditPromotion" :value="3"
                            >Free delivery</v-btn
                          >
                          <v-btn :disabled="isEditPromotion" :value="2"
                            >Messenger</v-btn
                          >
                        </v-btn-toggle>
                      </v-flex>
                      <v-flex xs12 style="font-size: 16px" class="mt-4">
                        <span>Promotion model :</span>
                      </v-flex>
                      <v-flex xs12 class="mt-3">
                        <v-select
                          solo
                          v-model="form.promotion_category"
                          :items="promotion_model1_item"
                          item-text="name"
                          item-value="value"
                          :label="
                            form.promotion_order_type == 1
                              ? 'Promotion food model'
                              : 'Promotion free model'
                          "
                          :rules="[rules.required]"
                          v-if="
                            form.promotion_order_type == 1 ||
                            form.promotion_order_type == 3
                          "
                          @change="resetCategoryValue()"
                          :disabled="isEditPromotion"
                        ></v-select>
                        <v-select
                          solo
                          :disabled="isEditPromotion"
                          v-model="form.promotion_category"
                          :items="promotion_model2_item"
                          item-text="name"
                          item-value="value"
                          label="Promotion messenger model"
                          :rules="[rules.required]"
                          v-if="form.promotion_order_type == 2"
                          @change="resetCategoryValue()"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-layout>

                  <!-- PROMOTION MODEL -->
                  <FixProductPrice
                    :form="form"
                    v-if="
                      form.promotion_category &&
                      ((form.promotion_category == 1 &&
                        (form.promotion_order_type == 1 ||
                          form.promotion_order_type == 3)) ||
                        (form.promotion_category == 2 &&
                          (form.promotion_order_type == 1 ||
                            form.promotion_order_type == 3)) ||
                        form.promotion_category == 3 ||
                        form.promotion_category == 9)
                    "
                    :hideFixPrice="
                      form.promotion_category == 1 ||
                      form.promotion_category == 2
                    "
                  ></FixProductPrice>
                  <fixProductPriceStore
                    @include="includePartner()"
                    @includeNo="includeNoPartner()"
                    @clearInclude="clearInclude()"
                    @select="selectStore($event)"
                    :promotion_stores="promotion_stores"
                    :form="form"
                    v-else-if="
                      form.promotion_category && form.promotion_category == 4
                    "
                  ></fixProductPriceStore>
                  <fixProduct
                    :form="form"
                    :promotion_products="promotion_products"
                    v-else-if="
                      form.promotion_category && form.promotion_category == 5
                    "
                  ></fixProduct>
                  <fixStoreDelivery
                    @include="includePartner()"
                    @includeNo="includeNoPartner()"
                    @clearInclude="clearInclude()"
                    @select="selectStore($event)"
                    :form="form"
                    :promotion_stores="promotion_stores"
                    v-else-if="
                      form.promotion_category && form.promotion_category == 6
                    "
                  ></fixStoreDelivery>
                  <GetItemFixStoreFixProductPrice
                    :form="form"
                    :promotion_product_gifts="promotion_product_gifts"
                    :promotion_stores="promotion_stores"
                    @clearPromotionProducts="clearPromotionProducts()"
                    v-else-if="
                      form.promotion_category && form.promotion_category == 7
                    "
                  ></GetItemFixStoreFixProductPrice>
                  <GetItemFixProductFixProductPrice
                    :form="form"
                    :promotion_products="promotion_products"
                    :promotion_product_gifts="promotion_product_gifts"
                    :promotion_stores="promotion_stores"
                    @clearPromotionProducts="clearPromotionProducts()"
                    v-else-if="
                      form.promotion_category && form.promotion_category == 8
                    "
                  ></GetItemFixProductFixProductPrice>

                  <!-- GENERATE CODE -->
                  <v-layout row wrap class="mt-4">
                    <v-flex xs12 style="font-size: 16px">
                      <p>Generate Code :</p>
                    </v-flex>
                    <v-flex xs12>
                      <v-card color="secondary">
                        <v-card-text class="pa-5">
                          <v-layout row wrap>
                            <v-flex xs6 class="pr-4">
                              <v-select
                                v-model="form.promotion_type"
                                :items="promotion_type_item_food"
                                item-text="name"
                                label="Promotion food type"
                                :rules="[rules.required]"
                                v-if="form.promotion_order_type == 1"
                                :disabled="isEditPromotion"
                              ></v-select>
                              <v-select
                                v-model="form.promotion_type"
                                :items="promotion_type_item_free"
                                item-text="name"
                                label="Promotion free type"
                                :rules="[rules.required]"
                                v-if="form.promotion_order_type == 3"
                                :disabled="isEditPromotion"
                              ></v-select>
                              <v-select
                                v-model="form.promotion_type"
                                :items="promotion_type_item_mess"
                                item-text="name"
                                label="Promotion messenger type"
                                :rules="[rules.required]"
                                v-if="form.promotion_order_type == 2"
                                :disabled="isEditPromotion"
                              ></v-select>
                            </v-flex>
                            <!-- ถ้าใส่ข้อมูลใน Promotion code (Prefix) แล้วจะกรอกไม่ได้ -->
                            <v-flex xs6 class="pl-4">
                              <v-text-field
                                :disabled="
                                  (editedIndex == -1 &&
                                    promotion_code_prefix == '') ||
                                  promotion_code_prefix == null
                                    ? false
                                    : true || isEditPromotion
                                "
                                :label="
                                  editedIndex == -1
                                    ? 'Promotion Code (Fix)'
                                    : 'Promotion Code'
                                "
                                v-model="promotion_code_fix"
                                placeholder="ex.WESTAFF2"
                                :rules="[rules.max]"
                                @input="toUpperCodeFix($event)"
                              ></v-text-field>
                            </v-flex>

                            <!-- ถ้าใส่ข้อมูลใน Promotion code (fix) แล้วจะกรอกไม่ได้ -->
                            <v-flex xs6 class="pr-4">
                              <v-text-field
                                :disabled="
                                  (editedIndex == -1 &&
                                    promotion_code_fix == '') ||
                                  promotion_code_fix == null
                                    ? false
                                    : true || isEditPromotion
                                "
                                label="Promotion Code (Prefix)"
                                v-model="promotion_code_prefix"
                                placeholder="ex.WExxxxxx"
                                :rules="[rules.max]"
                                @input="toUpperCodePreFix($event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6 class="pl-4">
                              <v-text-field
                                label="Amount of Prefix code"
                                v-model.number="form.promotion_count_prefix"
                                :disabled="
                                  (editedIndex == -1 &&
                                    promotion_code_fix == '') ||
                                  promotion_code_fix == null
                                    ? false
                                    : true || isEditPromotion
                                "
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- DISCOUNT TYPE -->
                          <v-layout row wrap>
                            <v-flex xs6 sm6 class="pr-4">
                              <v-radio-group
                                v-model="form.promotion_unit"
                                row
                                style="margin-top: 15px"
                                :rules="[rules.required]"
                              >
                                <v-radio
                                  label="Bath"
                                  :value="1"
                                  color="black"
                                ></v-radio>
                                <v-radio
                                  label="Percent"
                                  :value="2"
                                  color="black"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs6 sm6 class="pl-4">
                              <v-text-field
                                :disabled="isEditPromotion"
                                label="Discount price"
                                v-model="form.promotion_discount"
                                :rules="[
                                  rules.required,
                                  rules.percent,
                                  rules.onlyNumber,
                                ]"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 class="pr-4">
                              <v-text-field
                                :disabled="isEditPromotion"
                                label="Maximum discount"
                                v-model.number="form.promotion_maximum_discount"
                                :rules="[rules.required, rules.onlyNumber]"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 class="pl-4">
                              <v-text-field
                                :disabled="isEditPromotion"
                                label="Amount of time per use"
                                v-model.number="form.promotion_amount"
                                :rules="[rules.required, rules.onlyNumber]"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 class="pr-4">
                              <v-select
                                label="Payment method"
                                item-text="name"
                                item-value="value"
                                v-model="form.promotion_payment_type[0]"
                                :items="[
                                  { name: 'All', value: 0 },
                                  { name: 'COD', value: 1 },
                                  { name: 'Credit/Debit card', value: 2 },
                                  { name: 'PromptPay', value: 3 },
                                  { name: 'COIN', value: 4 },
                                ]"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <!-- CALENDAR -->
                            <v-flex xs6 class="pr-4">
                              <v-text-field
                                disabled
                                slot="activator"
                                v-model="form.promotion_start_date"
                                label="Select start date"
                                prepend-icon="event"
                                readonly
                                :rules="[rules.required]"
                                v-if="editedIndex != -1"
                              ></v-text-field>
                              <v-menu
                                :close-on-content-click="false"
                                v-model="start_date"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                                v-if="editedIndex == -1"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="form.promotion_start_date"
                                  label="Select start date"
                                  prepend-icon="event"
                                  readonly
                                  :rules="[rules.required]"
                                ></v-text-field>
                                <v-date-picker
                                  :min="moment().format('YYYY-MM-DD')"
                                  color="black"
                                  no-title
                                  v-model="form.promotion_start_date"
                                  @input="start_date = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs6 class="pl-4">
                              <v-text-field
                                disabled
                                slot="activator"
                                v-model="form.promotion_end_date"
                                label="Select end date"
                                prepend-icon="event"
                                readonly
                                :rules="[rules.required]"
                                v-if="editedIndex != -1"
                              ></v-text-field>
                              <v-menu
                                :close-on-content-click="false"
                                v-model="end_date"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                                v-if="editedIndex == -1"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="form.promotion_end_date"
                                  label="Select end date"
                                  color="black"
                                  prepend-icon="event"
                                  readonly
                                  :rules="[rules.required]"
                                ></v-text-field>
                                <v-date-picker
                                  :min="moment().format('YYYY-MM-DD')"
                                  color="black"
                                  no-title
                                  v-model="form.promotion_end_date"
                                  @input="end_date = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          flat
          :disabled="isLoadingAddEdit || isEditPromotion"
          @click="cancel()"
          >Cancel</v-btn
        >
        <v-btn
          color="green"
          flat
          @click="save()"
          :loading="isLoadingAddEdit"
          :disabled="isEditPromotion"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FixProductPrice from "./FixFormDelivery/FixProductPrice";
import fixProductPriceStore from "./FixFormDelivery/FixProductPriceStore";
import fixProduct from "./FixFormDelivery/FixProduct";
import fixStoreDelivery from "./FixFormDelivery/FixStore";
import GetItemFixStoreFixProductPrice from "./FixFormDelivery/GetItemFixStoreFixProductPrice"; // 7
import GetItemFixProductFixProductPrice from "./FixFormDelivery/GetItemFixProductFixProductPrice";
export default {
  props: ["dialog", "editedIndex", "selected_item"],
  components: {
    FixProductPrice,
    fixProductPriceStore,
    fixProduct,
    fixStoreDelivery,
    GetItemFixStoreFixProductPrice,
    GetItemFixProductFixProductPrice,
  },
  data() {
    return {
      // NEW LAYOUT
      toggle: 0,
      // END NEW LAYOUT
      isLoadingAddEdit: false,
      fetching_data: false,
      rules: {
        onlyNumber: (value) =>
          /^[0-9+.]*$/.test(value) || "only numbers are allowed.",
        required: (value) => !!value || "Required.",
        code: (value) => this.validateCode(value) || "Required.",
        percent: (value) =>
          this.validatePercent(value) || "must be less than 100",
        max: (v) => v.length <= 8 || "Maximum characters is 8",
        requiredStore: (value) =>
          (!!value && value.store_id != 0) || "Required.",
        alreadyStore: (value) =>
          value.store_id != -1 || "Store already to select.",
      },
      promotion_stores: [null],
      promotion_product_gifts: [],
      promotion_products: [{ store: null, product: null }],
      promotion_code_fix: "",
      promotion_code_prefix: "",
      form: {
        promotion_name_th: null,
        promotion_name_en: null,
        promotion_name_cn: null,
        promotion_detail: null,
        promotion_unit: 1,
        promotion_payment_type: [0],
        promotion_package: [],
        isAllPackage: true,
        promotion_package_store: [],
        isAllPackageStore: true,
      },
      select: 0,
      valid: true,
      order_type: [
        {
          name: "Food",
          value: 1,
        },
        {
          name: "Messenger",
          value: 2,
        },
      ],
      promotion_type_item_free: [
        {
          name: "Product",
          value: 1,
        },
      ],
      promotion_type_item_food: [
        {
          name: "Transport",
          value: 2,
        },
        {
          name: "Product",
          value: 1,
        },
        {
          name: "Product & transport",
          value: 3,
        },
      ],
      promotion_type_item_mess: [
        {
          name: "Transport",
          value: 2,
        },
      ],
      budget_type_item: [
        {
          name: "WESERVE",
          value: 1,
        },
        {
          name: "Store",
          value: 2,
        },
        {
          name: "Co-promotion",
          value: 3,
        },
      ],
      discount_type_item: [
        {
          name: "Percent",
          value: 1,
        },
        {
          name: "Bath",
          value: 2,
        },
      ],
      promotion_model1_item: [
        {
          name: "Normal",
          value: 1,
        },
        {
          name: "Order first time - Dont Fix Price",
          value: 2,
        },
        {
          name: "Order first time - Fix Price",
          value: 9,
        },
        {
          name: "Fix product price",
          value: 3,
        },
        {
          name: "Fix product price and fix store",
          value: 4,
        },
        {
          name: "Fix product",
          value: 5,
        },
        {
          name: "Fix store",
          value: 6,
        },
        {
          name: "Get item by fix store and fix product price",
          value: 7,
        },
        {
          name: "Get item by fix product and fix product price",
          value: 8,
        },
      ],
      promotion_model2_item: [
        {
          name: "Normal",
          value: 1,
        },
        {
          name: "Order first time - Dont Fix Price",
          value: 2,
        },
        {
          name: "Order first time - Fix Price",
          value: 9,
        },
      ],
      start_date: false,
      end_date: false,
    };
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        this.fetching_data = true;
        this.select = 0;
        this.resetPromotionProduct();
        this.resetPromotionStore();
        this.resetProductGift();
        await this.$store.dispatch("fetchStoreBack/getStoreList");
        if (this.editedIndex == -1) {
          this.promotion_code_fix = "";
          this.form = {
            promotion_name_th: null,
            promotion_name_en: null,
            promotion_name_cn: null,
            promotion_detail: null,
            promotion_unit: 1,
            promotion_payment_type: [0],
            promotion_package: [],
            isAllPackage: true,
            promotion_package_store: [],
            isAllPackageStore: true,
          };
        } else {
          let result = await this.$store.dispatch(
            "fetchFoodPromotionBack/getPromotionDetail",
            this.selected_item.promotion_id
          );

          if (result.promotion_store) {
            if (
              result.promotion_category == 6 ||
              result.promotion_category == 4
            ) {
              this.promotion_stores = [];
              for (let val of result.promotion_store) {
                let store = this.store_list.find(
                  (val2) => val2.store_id == val
                );

                if (store) {
                  this.promotion_stores.push(store);
                }
              }
            } else {
              this.promotion_stores = result.promotion_store;
            }
          }
          if (result.promotion_product) {
            this.promotion_products = result.promotion_product;
          }
          if (result.promotion_product_gift) {
            this.promotion_product_gifts = result.promotion_product_gift;
          }

          this.promotion_code_fix = result.promotion_code;

          if (
            result.promotion_package.length > 0 &&
            result.promotion_package[0] == 0
          ) {
            result.isAllPackage = true;
          } else {
            result.isAllPackage = false;
          }
          if (result.promotion_package_store) {
            if (
              (result.promotion_package_store.length > 0 &&
                result.promotion_package_store[0] == 0) ||
              result.promotion_package_store.length == 0
            ) {
              result.isAllPackageStore = true;
            } else {
              result.isAllPackageStore = false;
            }
          }
          console.log(result.promotion_package_store);
          this.form = JSON.parse(JSON.stringify(result));

          // promotion_payment_type
          //    promotion_package: [],
          //   isAllPackage: true,
          //   promotion_package_store: [],
          //   isAllPackageStore: true,
          // this.form.isAllPackageStore = true;
        }
        this.fetching_data = false;
        // this.$refs.form.resetValidation();
        this.promotion_code_prefix = "";
      }
    },
  },
  computed: {
    ...mapState({
      promotion_list: (state) => state.fetchFoodPromotionBack.promotion_list,
    }),
    ...mapGetters({
      isEditPromotion: "isEditPromotion",
      store_list_free: "fetchStoreBack/autocompleteStoreFreedelivery",
      store_list: "fetchStoreBack/autocompleteStore",
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New promotion" : "Edit promotion";
    },
  },
  methods: {
    cancel() {
      this.$emit("setDialog", false);
      this.$emit("setEditIndex", -1);
    },
    selectStore(payload) {
      if (payload.value == undefined) {
        this.promotion_stores.splice(payload.index, 1, {
          store_id: 0,
        });
        return;
      }

      if (
        !this.promotion_stores.some(
          (val) => val.store_id == payload.value.store_id
        )
      ) {
        this.promotion_stores.splice(payload.index, 1, payload.value);
      } else {
        this.promotion_stores.splice(payload.index, 1);
        if (
          this.promotion_stores[0].store_id != 0 &&
          this.promotion_stores[0].store_id != -1
        ) {
          this.promotion_stores.unshift({ store_id: -1 });
        }
      }
    },
    clearInclude() {
      this.promotion_stores = [{ store_id: 0 }];
    },
    includePartner() {
      this.promotion_stores = [];
      if (this.form.promotion_order_type == 3) {
        for (let val of this.store_list_free) {
          if (val.store_partner == true) {
            this.promotion_stores.push(val);
          }
        }
      } else {
        for (let val of this.store_list) {
          if (val.store_partner == true) {
            this.promotion_stores.push(val);
          }
        }
      }
    },
    includeNoPartner() {
      this.promotion_stores = [];
      if (this.form.promotion_order_type == 3) {
        for (let val of this.store_list_free) {
          if (val.store_partner == false) {
            this.promotion_stores.push(val);
          }
        }
      } else {
        for (let val of this.store_list) {
          if (val.store_partner == false) {
            this.promotion_stores.push(val);
          }
        }
      }
    },
    resetOrderTypeValue() {
      delete this.form.promotion_category;
      this.resetCategoryValue();
    },
    clearPromotionProducts() {
      this.resetProductGift();
      this.resetPromotionProduct();
    },
    toUpperCodeFix(value) {
      this.promotion_code_fix = value.toUpperCase();
    },
    toUpperCodePreFix(value) {
      this.promotion_code_prefix = value.toUpperCase();
    },
    resetCategoryValue() {
      this.resetPromotionProduct();
      this.resetPromotionStore();
      this.resetProductGift();
      this.form.promotion_store = [];
      delete this.form.promotion_fix_price;
      delete this.form.promotion_gift_amount;
    },
    codeAlready(value) {
      let check = 0;
      for (let val of this.promotion_list) {
        if (val.promotion_code.toLowerCase() == value.toLowerCase()) {
          check = 1;
        }
      }

      if (check == 1) {
        return false || "Promotion code already exist.";
      } else {
        return true;
      }
    },
    changeOrderType() {
      delete this.form.promotion_category;
      this.$refs.form.resetValidation();
    },
    validatePercent() {
      if (this.form.promotion_unit == 2) {
        if (this.form.promotion_discount > 100) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    validateCode() {
      if (
        (this.promotion_code_fix == null || this.promotion_code_fix == "") &&
        (this.promotion_code_prefix == null || this.promotion_code_prefix == "")
      ) {
        return false;
      } else {
        return true;
      }
    },
    async addPromotion() {
      if (this.promotion_code_fix == null || this.promotion_code_fix == "") {
        this.form.promotion_gen_code = true;
        this.form.promotion_code = this.promotion_code_prefix;
      } else if (
        this.promotion_code_prefix == null ||
        this.promotion_code_prefix == ""
      ) {
        this.form.promotion_count_prefix = 1;
        this.form.promotion_gen_code = false;
        this.form.promotion_code = this.promotion_code_fix;
      }
      let send_obj = JSON.parse(JSON.stringify(this.form));
      if (
        send_obj.promotion_category == 6 ||
        send_obj.promotion_category == 4
      ) {
        send_obj.promotion_store = this.promotion_stores.map(
          (val) => val.store_id
        );
      } else if (send_obj.promotion_category == 5) {
        send_obj.promotion_product = this.promotion_products;
      } else if (send_obj.promotion_category == 7) {
        send_obj.promotion_product_gift = this.promotion_product_gifts;
        send_obj.promotion_store = this.promotion_stores;
      } else if (send_obj.promotion_category == 8) {
        send_obj.promotion_product = this.promotion_products;
        send_obj.promotion_product_gift = this.promotion_product_gifts;
        send_obj.promotion_store = this.promotion_stores;
      }

      if (!send_obj.promotion_detail) {
        send_obj.promotion_detail = null;
      }
      if (!send_obj.promotion_name_cn) {
        send_obj.promotion_name_cn = null;
      }

      if (send_obj.isAllPackage == true) {
        send_obj.promotion_package = [0];
      }
      delete send_obj.isAllPackage;

      if (send_obj.isAllPackageStore == true) {
        send_obj.promotion_package_store = [0];
      } else {
        send_obj.promotion_package_store = this.form.promotion_package_store;
      }
      delete send_obj.isAllPackageStore;

      this.isLoadingAddEdit = true;
      await this.$store.dispatch(
        "fetchFoodPromotionBack/addPromotion",
        send_obj
      );
      this.isLoadingAddEdit = false;
      this.$emit("setDialog", false);
      this.$emit("setEditIndex", -1);
    },
    resetPromotionStore() {
      this.promotion_stores = new Array();
      this.promotion_stores.push({ store_id: 0 });
    },
    resetPromotionProduct() {
      this.promotion_products = new Array();
      this.promotion_products.push({ store: null, product: null });
    },
    resetProductGift() {
      this.promotion_product_gifts = new Array();
      this.promotion_product_gifts.push(null);
    },
    async editPromotion() {
      this.promotion_code_fix = this.form.promotion_code;
      let send_obj = JSON.parse(JSON.stringify(this.form));
      if (
        send_obj.promotion_category == 6 ||
        send_obj.promotion_category == 4
      ) {
        send_obj.promotion_store = this.promotion_stores.map(
          (val) => val.store_id
        );
      } else if (send_obj.promotion_category == 5) {
        send_obj.promotion_product = this.promotion_products;
      } else if (send_obj.promotion_category == 7) {
        send_obj.promotion_product_gift = this.promotion_product_gifts;
        send_obj.promotion_store = this.promotion_stores;
      } else if (send_obj.promotion_category == 8) {
        send_obj.promotion_product = this.promotion_products;
        send_obj.promotion_product_gift = this.promotion_product_gifts;
        send_obj.promotion_store = this.promotion_stores;
      }
      this.isLoadingAddEdit = true;

      if (!send_obj.promotion_detail) {
        send_obj.promotion_detail = null;
      }
      if (!send_obj.promotion_name_cn) {
        send_obj.promotion_name_cn = null;
      }

      if (send_obj.isAllPackage == true) {
        send_obj.promotion_package = [0];
      }
      delete send_obj.isAllPackage;

      if (send_obj.isAllPackageStore == true) {
        send_obj.promotion_package_store = [0];
      } else {
        send_obj.promotion_package_store = this.form.promotion_package_store;
      }
      delete send_obj.isAllPackageStore;

      await this.$store.dispatch(
        "fetchFoodPromotionBack/editPromotionDetail",
        send_obj
      );
      this.isLoadingAddEdit = false;
      this.$emit("setDialog", false);
      this.$emit("setEditIndex", -1);
    },
    save() {
      if (
        this.$refs.form.validate() &&
        !(
          this.form.isAllPackageStore == false &&
          this.form.promotion_package_store.length == 0
        )
      ) {
        if (this.editedIndex == -1) {
          this.addPromotion();
        } else {
          this.editPromotion();
        }
      }
    },
  },
};
</script>
<style>
.field-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.field-group-append {
  margin-left: -1px;
  display: flex;
}

.field-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  margin-top: 12px;
  color: #979090;
}
.style-title-promo {
  font-size: 15px;
  color: #616a6b;
}
.promo-title {
  padding-top: 21px;
}
</style>
